import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DeviceCartsPartialState } from './deviceCarts.reducer';
import { DeviceCartsQuery } from './deviceCarts.selectors';
import * as DeviceCartsActions from './deviceCarts.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';

@Injectable()
export class DeviceCartsFacade {

  all$ = this.store.pipe(select(DeviceCartsQuery.getAllDeviceCarts));
  allById$ = this.store.pipe(select(DeviceCartsQuery.getAllDeviceCartsById));
  searchResults$ = this.store.pipe(select(DeviceCartsQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(DeviceCartsQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(DeviceCartsQuery.getLastCreatedId));

  constructor(private store: Store<DeviceCartsPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  loadAll(correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(DeviceCartsActions.loadAll(), correlationId);
  }

  loadCartByDevice(factory: string, deviceId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.loadCartByDevice({factory: factory, deviceId: deviceId }),
      correlationId
    );
  }

  addToCart(
    factory: string,
    deviceId: string,
    id: string,
    featureId: string,
    salesRule: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.addToCart(
        {
          factory: factory,
          deviceId: deviceId,
          id: id,
          featureId: featureId,
          salesRule: salesRule
        }
      ),
      correlationId
    );
  }

  saveCart(
    factory: string,
    deviceId: string,
    id: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.saveCart(
        {
          factory: factory,
          deviceId: deviceId,
          id: id
        }
      ),
      correlationId
    );
  }

  placeOrder(cartId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.placeOrder({cartId: cartId}),
      correlationId
    );
  }

  removeFromCart(
    factory: string,
    deviceId: string,
    cartId: string,
    entry: number,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.removeFromCart(
        {
          factory: factory,
          deviceId: deviceId,
          cartId: cartId,
          entry: entry
        }
      ),
      correlationId
    )
  }

  clearStore(correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.clearStore(),
      correlationId
    );
  }

  update(
    factory: string,
    deviceId: string,
    quoteId: string,
    status: string,
    note: string,
    poNumber: string,
    ccRecipients: string[],
    poDate: string,
    cartId: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.updateCart(
         {
            factory: factory,
            quoteId: quoteId,
            cartId: cartId,
            status: status,
            note: note,
            poNumber: poNumber,
            ccRecipients: ccRecipients,
            poDate: poDate,
            deviceId: deviceId
         }
      ),
      correlationId
    )
  }

  delete(factory: string, deviceId: string, cartId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      DeviceCartsActions.deleteCart({factory: factory, deviceId: deviceId, cartId: cartId}),
      correlationId
    );
  }
}
